import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { SketchPicker } from 'react-color';

const PICKER_W = 225;
const PICKER_H = 300;

const ColorOption = ({ defaultValue, onChange }) => {
  const [show, setShow] = useState(false);
  const [color, setColor] = useState(defaultValue);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const triggerRef = useRef();
  const panelRef = useRef();

  useEffect(() => {
    setColor(defaultValue);
  }, [defaultValue]);

  const handleChange = (color) => {
    const hexColor = convertRGBAToHex(color.rgb);
    setColor(hexColor);
    onChange(hexColor);
  };

  const convertRGBAToHex = (color) => {
    let r = color.r.toString(16);
    let g = color.g.toString(16);
    let b = color.b.toString(16);
    let a = Math.round(color.a * 255).toString(16);

    if (r.length === 1) r = '0' + r;
    if (g.length === 1) g = '0' + g;
    if (b.length === 1) b = '0' + b;
    if (a.length === 1) a = '0' + a;

    return '#' + r + g + b + a;
  };

  // Position the picker next to the swatch, flipping above / clamping to the
  // viewport so it's never clipped by a scrolling or overflow-hidden panel.
  const openPicker = () => {
    const rect = triggerRef.current && triggerRef.current.getBoundingClientRect();
    if (rect) {
      let left = Math.min(rect.left, window.innerWidth - PICKER_W - 8);
      left = Math.max(8, left);
      let top = rect.bottom + 6;
      if (top + PICKER_H > window.innerHeight) {
        top = Math.max(8, rect.top - PICKER_H - 6);
      }
      setPos({ top, left });
    }
    setShow(true);
  };

  const handleClickOutside = (event) => {
    if (triggerRef.current && triggerRef.current.contains(event.target)) return;
    if (panelRef.current && panelRef.current.contains(event.target)) return;
    setShow(false);
  };

  useEffect(() => {
    if (!show) return undefined;
    document.addEventListener('mousedown', handleClickOutside);
    // A fixed-position picker would drift from the swatch on scroll, so close it.
    const close = () => setShow(false);
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
    };
  }, [show]);

  return (
    <div className="un-color-option">
      <div className="display" ref={triggerRef} onClick={() => (show ? setShow(false) : openPicker())}>
        <div className="preview-block" style={{ backgroundColor: color }}></div>
        {color.toUpperCase()}
      </div>
      {show &&
        createPortal(
          <div
            className="un-color-portal"
            ref={panelRef}
            style={{ position: 'fixed', top: pos.top, left: pos.left, zIndex: 9999 }}
          >
            <SketchPicker color={color} onChange={handleChange} />
          </div>,
          document.body
        )}
    </div>
  );
};

export default ColorOption;
